import React from 'react';
import PropTypes from 'prop-types';

/**
 * Label - A wrapper that renders a standard HTML label with Bulma class names
 * 
 * This component accepts the same props as Bloomer Label for easy migration
 */
const Label = ({
  className = '',
  children = null,
  style = {},
  htmlFor = '',
  hasTextColor = null,
  isSize = null,
  ...props
}) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['label'];
    
    // Add appropriate classes based on props
    if (isSize) {
      classes.push(`is-${isSize}`);
    }
    
    if (hasTextColor) {
      classes.push(`has-text-${hasTextColor}`);
    }
    
    // Add custom class names
    if (className) {
      classes.push(className);
    }
    
    return classes.join(' ');
  };

  return (
    <label 
      className={getClassNames()} 
      style={style} 
      htmlFor={htmlFor}
      {...props}
    >
      {children}
    </label>
  );
};

// eslint-disable-next-line react/require-default-props
Label.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
  htmlFor: PropTypes.string,
  hasTextColor: PropTypes.string,
  isSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ])
};



export default Label;
